var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLeftShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 529,
    viewBox: "0 0 530 529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3693 131.142C83.3049 143.832 82.5151 159.778 88.1379 176.183C90.7171 183.706 158.001 344.395 161.124 350.489C177.924 383.267 211.088 390.965 238.718 368.499L243.619 364.514L303.691 285.678L363.764 206.841L366.201 201.255C380.307 168.921 364.181 139.058 328.537 131.507C322.295 130.184 146.579 107.644 139.58 107.268C122.74 106.364 107.711 111.508 97.511 121.67C95.1801 123.993 93.2277 125.983 93.1721 126.091C93.1168 126.2 91.8549 128.474 90.3693 131.142ZM129.279 148.529C133.876 147.039 130.745 146.699 229.292 159.363C330.13 172.322 324.122 171.397 328.344 174.614C331.438 176.972 331.571 179.332 328.922 184.979C326.752 189.606 215.556 335.245 212.368 337.635C205.606 342.703 201.892 341.22 197.21 331.581C195.014 327.06 127.963 166.403 126.727 162.701C123.85 154.085 124.577 150.055 129.279 148.529Z",
    fill: "url(#paint0_linear_169_30452)",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.369 62.6607C317.473 62.4643 314.346 61.7338 311.419 61.0365C184.724 30.828 60.3225 127.192 56.3731 258.599C53.1816 364.831 132.794 457.557 238.829 471.108C321.277 481.645 403.13 441.309 444.821 369.596C506.395 263.683 464.727 128.899 353.954 75.6601C348.487 73.0327 322.659 63.5976 318.369 62.6607ZM318.937 145.074C411.6 187.189 422.481 314.879 338.308 372.365C259.32 426.311 149.996 378.716 135.59 284.108C120.019 181.857 224.891 102.329 318.937 145.074Z",
    fill: "url(#paint1_linear_169_30452)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_30452",
    x1: 111.061,
    y1: 320.545,
    x2: 285.929,
    y2: 91.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_30452",
    x1: 67.4872,
    y1: 197.255,
    x2: 462.253,
    y2: 331.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF832A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLeftShapes);
export default __webpack_public_path__ + "static/media/Footer_Left_Shapes.61c969bbd1e51eacab74686df3433eaf.svg";
export { ForwardRef as ReactComponent };